// extracted by mini-css-extract-plugin
export var borderRadius = "_9u-4";
export var large = "_9u-3";
export var logoContainer = "_9u-0";
export var nameLogo = "_9u-2";
export var small = "_9u-1";